<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="优惠券名称" prop="couponName">
        <el-input v-model="form.couponName" placeholder="请输入名字" v-trim />
      </el-form-item>

      <el-form-item label="领取方式" prop="acquireMethod">
        <el-select
          v-model="form.acquireMethod"
          placeholder="请选择领取方式"
          clearable
        >
          <el-option label="免费领取" value="FREE"></el-option>
          <el-option label="付费购" value="PURCHASE"></el-option>
          <el-option label="积分兑换" value="POINTS"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="购买所需金额"
        prop="purchaseRequiredAmount"
        v-if="showPurchaseAmount"
      >
        <el-input
          v-model="form.purchaseRequiredAmount"
          placeholder="请输入购买所需金额"
          v-trim
          type="number"
          min="0"
          style="width: 95%"
        />
        <span style="margin-left: 10px">元</span>
      </el-form-item>

      <el-form-item
        label="所需积分"
        prop="requiredPoints"
        v-if="showRequiredPoints"
      >
        <el-input
          v-model="form.requiredPoints"
          placeholder="请输入积分数量"
          v-trim
          type="number"
          min="0"
          style="width: 95%"
        />
      </el-form-item>

      <el-form-item label="详情" prop="description">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 12 }"
          v-model="form.description"
          placeholder="请输入详情介绍"
          v-trim
        />
      </el-form-item>
      <el-form-item label="折扣条件">
        <div class="discount-condition">
          <span class="condition-text">满</span>
          <el-input
            v-model="form.minAmount"
            placeholder="请输入金额"
            v-trim
            class="amount-input"
            type="number"
            min="0"
          />
          <span class="condition-text">元减</span>
          <el-input
            v-model="form.discountAmount"
            placeholder="请输入金额"
            v-trim
            class="amount-input"
            type="number"
            min="0"
          />
          <span class="condition-text">元</span>
        </div>
      </el-form-item>
      <el-form-item label="有效时长" prop="valid_date">
        <el-input
          v-model="form.valid_date"
          placeholder="请输入有效时长"
          v-trim
          type="number"
          min="0"
        >
          <el-select
            v-model="select"
            slot="append"
            style="width: 120px"
            placeholder="请选择单位"
          >
            <el-option label="小时" value="1"></el-option>
            <el-option label="天" value="2"></el-option>
            <el-option label="月" value="3"></el-option>
            <el-option label="年" value="4"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="使用场景" prop="useScene">
        <el-select
          v-model="form.useScene"
          placeholder="请选择使用场景"
          filterable
          remote
          reserve-keyword
          :loading="tagLoading"
          @keypress.enter.native="search"
        >
          <el-option
            v-for="(item, itemIndex) in useSceneList"
            :key="itemIndex"
            :label="item.desc"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="延期场景" prop="extendScene">
        <el-select
          v-model="form.extendScene"
          placeholder="请选择延期场景"
          filterable
          multiple
          :multiple-limit="2"
          remote
          reserve-keyword
          :loading="tagLoading"
          @keypress.enter.native="search"
        >
          <el-option
            v-for="(item, itemIndex) in extendSceneList"
            :key="itemIndex"
            :label="item.desc"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="延期时长" prop="extend_date">
        <el-input
          v-model="form.extend_date"
          placeholder="请输入延期时长"
          v-trim
          type="number"
          min="0"
        >
          <el-select
            v-model="extend_select"
            slot="append"
            style="width: 120px"
            placeholder="请选择单位"
          >
            <el-option label="小时" value="1"></el-option>
            <el-option label="天" value="2"></el-option>
            <el-option label="月" value="3"></el-option>
            <el-option label="年" value="4"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="延期收费金额" prop="requiredAmount">
        <el-input
          v-model="form.requiredAmount"
          placeholder="请输入金额"
          v-trim
          type="number"
          min="0"
          style="width: 95%"
        />
        <span style="margin-left: 10px">元</span>
      </el-form-item>
      <el-form-item label="延期所需积分" prop="extendRequiredPoints">
        <el-input
          v-model="form.extendRequiredPoints"
          placeholder="请输入延期所需积分数量"
          v-trim
          type="number"
          min="0"
          style="width: 95%"
        />
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { getUseScene, getExtendScene } from '@/api/rentHouse/couponTemplate'

export default {
  name: 'OperaCouponTemplateWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        couponName: '',
        description: '',
        minAmount: null,
        discountAmount: null,
        valid_date: null, // 将小时转换为日期
        extend_date: null,
        validHours: null,
        extendHours: null,
        useScene: '',
        extendScene: [],
        requiredAmount: null,
        purchaseRequiredAmount: null,
        acquireMethod: '',
        requiredPoints: null,
        extendRequiredPoints: null,
        delFlag: 0
      },
      imgUrl: process.env.VUE_APP_API_IMG,
      forUserList: [],
      tagLoading: false,
      useSceneList: [],
      extendSceneList: [],
      select: '1',
      extend_select: '1',
      // 验证规则
      rules: {
        couponName: [{ required: true, message: '请输入优惠券名称' }],
        acquireMethod: [{ required: true, message: '请选择领取方式' }],
        purchaseRequiredAmount: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireMethod === 'PURCHASE') {
                if (value == null || value === '' || Number(value) <= 0) {
                  callback(new Error('购买所需金额必须填写且大于0'))
                  return
                }
              }
              callback()
            },
            trigger: 'change'
          }
        ],
        requiredPoints: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireMethod === 'POINTS') {
                if (value == null || value === '' || Number(value) <= 0) {
                  callback(new Error('所需积分必须填写且大于0'))
                  return
                }
              }
              callback()
            },
            trigger: 'change'
          }
        ]
      }
    }
  },

  watch: {
    'form.acquireMethod' (val) {
      if (val === 'PURCHASE') {
        this.form.requiredPoints = null
      } else if (val === 'POINTS') {
        this.form.purchaseRequiredAmount = null
      } else {
        this.form.purchaseRequiredAmount = null
        this.form.requiredPoints = null
      }
    }
  },
  created () {
    this.config({
      api: '/rentHouse/couponTemplate',
      'field.id': 'id'
    })
    const extendsOpen = this.open.bind(this)
    this.open = (title, target) => {
      extendsOpen(title, target)
      // 获取使用场景和延期场景数据
      this.loadSceneData()
      this.$nextTick(() => {
        if (!target) {
          this.form.minAmount = null
          this.form.discountAmount = null
          this.form.extendScene = []
        } else {
          // 编辑时处理延期场景数据回显
          if (target.extendScene) {
            // 如果是字符串，转换为数组
            if (typeof target.extendScene === 'string') {
              this.form.extendScene = target.extendScene
                .split(',')
                .filter((item) => item.trim() !== '')
            } else {
              this.form.extendScene = []
            }
          } else {
            this.form.extendScene = []
          }
        }
        this.form.validHours = target?.validHours || 0
        this.form.extendHours = target?.extendHours || 0
        const autoUnitAndDafaultHour = this.autoUnitAndDafaultHour
        const extendUnitAndDafaultHour = this.extendUnitAndDafaultHour
        this.select = autoUnitAndDafaultHour.select
        this.form.valid_date = autoUnitAndDafaultHour.valid_date
        this.extend_select = extendUnitAndDafaultHour.select
        this.form.extend_date = extendUnitAndDafaultHour.valid_date
      })
    }
    this.$on('hook:mounted', () => {
      // 监听 visible 的变化
      this.$watch('visible', (newVal, oldVal) => {
        // 当弹窗从显示变为隐藏时（即点击取消或关闭）
        if (oldVal === true && newVal === false) {
          this.select = '1'
          this.extend_select = '1'
          this.form.extendScene = []
        }
      })
    })

    const actionConfirm = this.confirm.bind(this)
    this.confirm = (...data) => {
      const submitForm = { ...this.form }
      submitForm.validHours = this.validHours
      submitForm.extendHours = this.extendHours
      if (Array.isArray(submitForm.extendScene)) {
        submitForm.extendScene = submitForm.extendScene
          .filter((item) => item && item.trim() !== '')
          .join(',')
      } else if (!submitForm.extendScene) {
        submitForm.extendScene = ''
      }
      const originalForm = this.form
      this.form = submitForm
      const result = actionConfirm(...data)
      // 提交后恢复原始form数据（保持延期场景为数组格式）
      this.form = originalForm
      this.form.validHours = this.validHours
      this.form.extendHours = this.extendHours

      return result
    }
  },
  computed: {
    showPurchaseAmount () {
      return this.form.acquireMethod === 'PURCHASE'
    },
    showRequiredPoints () {
      return this.form.acquireMethod === 'POINTS'
    },
    validHours () {
      return this.changeDateToHours(this.select, this.form.valid_date)
    },
    extendHours () {
      return this.changeDateToHours(this.extend_select, this.form.extend_date)
    },
    autoUnitAndDafaultHour () {
      return this.autoChangeUnit(this.form.validHours)
    },
    extendUnitAndDafaultHour () {
      return this.autoChangeUnit(this.form.extendHours)
    }
  },
  methods: {
    // 加载场景数据
    async loadSceneData () {
      const uselist = await getUseScene()
      const extendlist = await getExtendScene()
      this.useSceneList = uselist
      this.extendSceneList = extendlist
    },
    autoChangeUnit (data) {
      const totalHours = data
      const years = totalHours / (24 * 30 * 12)
      const months = totalHours / (24 * 30)
      const days = totalHours / 24
      const hours = totalHours

      // 选择最合适的单位（优先选择整数或接近整数的单位）
      if (years >= 1 && years % 1 === 0) {
        // 整年
        return { select: '4', valid_date: years }
      } else if (months >= 1 && months % 1 === 0) {
        // 整月
        return { select: '3', valid_date: months }
      } else if (days >= 1 && days % 1 === 0) {
        // 整天
        return { select: '2', valid_date: days }
      } else if (years >= 1) {
        // 大于1年但不是整年，选择年
        return { select: '4', valid_date: years.toFixed(2) }
      } else if (months >= 1) {
        // 大于1月但不是整月，选择月
        return { select: '3', valid_date: months.toFixed(2) }
      } else if (days >= 1) {
        // 大于1天但不是整天，选择天
        return { select: '2', valid_date: days.toFixed(2) }
      } else {
        // 小于1天，选择小时
        return { select: '1', valid_date: hours.toFixed(2) }
      }
    },
    changeDateToHours (select, date) {
      switch (select) {
      case '1':
        return date
      case '2':
        return date * 24
      case '3':
        return date * 24 * 30
      case '4':
        return date * 24 * 30 * 12
      }
    }
  }
}
</script>

<style scoped>
.el-select-dropdown__item {
  height: auto !important;
}
.discount-condition {
  display: flex;
  align-items: center;
  gap: 8px;
}

.condition-text {
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
}

.amount-input {
  width: 120px;
  flex-shrink: 0;
}
.period-conversion {
  margin-top: 8px;
  padding: 6px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.period-conversion .el-icon-time {
  color: #409eff;
  font-size: 14px;
}

.conversion-text {
  color: #606266;
  font-size: 13px;
  font-weight: 500;
}
</style>
